module.exports = __webpack_public_path__ + "static/img/eight_lucky.1376a2c3.png";